export enum StandardDataSourceIds {
  AddCommentOnEntity = 'addCommentOnEntity',
  AddReplyToEntityComment = 'addReplyToEntityComment',
  DeleteEntityComment = 'deleteEntityComment',
  FetchRepliesOfEntityComment = 'fetchRepliesOfEntityComment',
  FetchEntityComments = 'fetchEntityComments',
  FetchUserPreferences = 'fetchUserPreferences',
  FetchTraces = 'fetchTraces',
  FetchTracesMetadata = 'fetchTracesMetadata',
  FetchSessions = 'fetchSessions',
  FetchSessionsMetadata = 'fetchSessionsMetadata',
  SetUserPreferences = 'setUserPreferences',
  FetchCalendarEvents = 'fetchCalendarEvents',
  FetchTimelineEvents = 'fetchTimelineEvents',
}
